<template>
  <div>
    <head>
      <!-- Add this line -->
      <link rel="stylesheet" :href="css">
    </head>
    <div class="black-overlay"></div>
    <div class="modal modal--postfreegame" id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close" @click="goToHomePage"><i class="icon-close"></i></button>
        <div class="game_bg pre_post" v-if="addOnBonusGameData.success">
          <div class="game_box">
            <div class="title"> {{ getTranslations.home_game_addongamelanterns_modals_post_game_lanterns_won_great  }}</div>
            <div class="subtitle" v-if="!isLantern">{{ getTranslations.home_game_addongamelanterns_modals_post_game_lanterns_won_you_are }}</div>
            <div class="subtitle" v-else>{{ getTranslations.home_game_addongamelanterns_modals_post_game_lanterns_won_bonus  }}</div>
            <img :src="image" alt="game background">
            <p class="won_lost">{{ getTranslations.home_game_addongamelanterns_modals_post_game_lanterns_won_you_earned  }}<br> {{addOnBonusGameData.prizeType}} {{ getTranslations.home_game_addongamelanterns_modals_post_game_lanterns_won_points  }}</p>
          </div>
        </div>
        <div class="game_bg pre_post" v-else>
          <div class="game_box">
            <div class="title">{{ getTranslations.home_game_addongamelanterns_modals_post_game_lanterns_lost_oh_no  }}</div>
            <div class="subtitle"> {{ getTranslations.home_game_addongamelanterns_modals_post_game_lanterns_lost_unfortunately  }}</div>
            <img :src="image" alt="game background">
            <p class="won_lost"> {{ getTranslations.home_game_addongamelanterns_modals_post_game_lanterns_lost_maybe  }}<br>  {{ getTranslations.home_game_addongamelanterns_modals_post_game_lanterns_lost_dont_give_up  }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>


<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'result-of-add-on-game',
  data() {
    return {
      showAddOnGame: false,
      css: '',
      image: '',
      isLantern: false,
    };
  },
  created() {
    if (this.fallingItemsAddOnGameCss === 'lanterns') {
      this.isLantern = true;
      this.image = '/static/mini_games/Falling_Lanterns_Game/assets/bg_lanterns.png';
      this.css = localStorage.getItem('locale') === ('AR' || 'KU') ?
        '../../../../../static/mini_games/Falling_Lanterns_Game/lanterns_AR.css' :
        '../../../../../static/mini_games/Falling_Lanterns_Game/lanterns.css';
    } else {
      this.image = '/static/mini_games/Falling_Lanterns_Game/assets/bg_meteorites.png';
      this.css = localStorage.getItem('locale') === ('AR' || 'KU') ?
        '../../../../../static/mini_games/Falling_Lanterns_Game/meteorites_AR.css' :
        '../../../../../static/mini_games/Falling_Lanterns_Game/meteorites.css';
    }
    const payload = {
      successful: this.addOnBonusGameData.success,
      achievementName: this.addOnBonusGameData.achievementName,
      prize: this.addOnBonusGameData.prizeType,
      gameType: 'LIGHT_THE_LANTERNS',
    };
    this.updateDBonusAddOnGames(payload);
  },
  beforeDestroy() {
    this.clearLanternGame();
    this.resetBonusAddOnGameData();
    this.setActiveAddOnMiniGame(false);
    // eslint-disable-next-line
    $('.header-main').show();
  },
  methods: {
    ...mapActions('profile', [
      'updateDBonusAddOnGames',
    ]),
    ...mapMutations('game', [
      'resetBonusAddOnGameData',
    ]),
    ...mapMutations('profile', [
      'clearLanternGame',
    ]),
    ...mapMutations('common', [
      'setActiveAddOnMiniGame',
    ]),
    goToHomePage() {
      this.$router.push('/home');
    },
  },
  computed: {
    ...mapState('common', [
      'addOnMode',
      'fallingItemsAddOnGameCss',
      'userDetails',
    ]),
    ...mapState('game', [
      'addOnBonusGameData',
      'gameID',
    ]),
    ...mapGetters('game', [
      'isHomePlayer',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>
<!--<style>-->
<!--  /* Import lanterns.css */-->
<!--  @import url('../../../../../../static/mini_games/Falling_Lanterns_Game/lanterns.css');-->
<!--</style>-->



// WEBPACK FOOTER //
// src/components/home/game/addongamelanterns/modals/ResultOfAddOnGame.vue